import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  flex-direction:column;
  gap: 20px;
  .title {
    font-size: 19px;
    font-weight: 500;
    line-height: 19.92px;
  }
  .indications {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
  }
  .indications p {
    font-size: 12px;
    font-weight: 400;
    line-height: 20.06px;
    text-align: left;
    color: var(--gray-contentoh);
  }
  .selects-container{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
`;